import { isEqual } from 'lodash';
import { DataTableFilterMeta, DataTableStateEvent } from 'primereact/datatable';
import { Dataset } from '../../../../types/types';
import { updateActiveFiltersFromLazyState } from '../../../../utils/filters/updateActiveFiltersFromLazyState';

// PrimeReact fires onFilter on every Apply/Clear click, changed or not, so the
// commit and the selection reset are gated separately: lazy state has to follow
// any raw change (it carries the matchMode the overlay shows), but the selection
// only resets when the request itself changes — a matchMode tweak on an unset
// filter rewrites lazy state without altering a single request param.
export const applyFilterChange = (
  previousFilters: DataTableFilterMeta | null,
  event: DataTableStateEvent,
  dataset: Dataset | undefined,
  setLazyState: (event: DataTableStateEvent) => void,
  resetSelectedRows: () => void
): void => {
  if (isEqual(previousFilters, event.filters)) return;

  setLazyState(event);

  // updateActiveFiltersFromLazyState reads dataset.items unguarded; without it
  // fall back to resetting, which is what this did before the guard existed.
  if (!dataset?.items) {
    resetSelectedRows();
    return;
  }

  const previousActiveFilters = updateActiveFiltersFromLazyState(
    null,
    { filters: previousFilters ?? {} },
    dataset
  );
  const nextActiveFilters = updateActiveFiltersFromLazyState(
    null,
    { filters: event.filters },
    dataset
  );
  if (isEqual(previousActiveFilters, nextActiveFilters)) return;

  resetSelectedRows();
};
